<template>
    <div>
      <!-- Main content -->
      <section class="content">
        <div class="box info-box">
          <div class="box-header with-border">
            
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3" v-if="canAccess('menu-branch')">
                <label for="Branch">Branch</label>
                <v-select v-model="branchFilter" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="changeByBankFilter"></v-select>
                
                <has-error
                  :form="form"
                  field="branch_id"
                ></has-error>
              </div>
              <div class="col-md-3" v-if="branch.id">
                <label for="Type">Type</label>
                <select
                  v-model="form.planType"
                  name="planType"
                  @change="getPlanType"
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('planType'),
                  }"
                  required
                >
                  <option v-if="!form.planType" selected value="">
                    Select plan Type
                  </option>
                  <option value="group">Group</option>
                  <option value="individual">Individual</option>
                </select>
                <has-error
                  :form="form"
                  field="planType"
                ></has-error>
              </div>
              <div class="col-md-3" v-if="form.planType === 'group'">
                <label for="Branch">Group</label>
                <v-select v-model="collectionCenter"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="changeFilter" required></v-select>
                <has-error
                  :form="form"
                  field="branch_id"
                ></has-error>
              </div>
              <div class="col-md-3" v-if="canAccess('branch-ledger-view-any')">
                <div class="form-group">
                  <label
                    >Select Payment Status <span class="red">*</span></label
                  >
                  <select
                    v-model="form.status"
                    name="status"
                    @change="changeFilter"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('status'),
                    }"
                  >
                    <option v-if="!form.status" selected value="">
                      Select Status
                    </option>
                    <option value="approved">Approved</option>
                    <option value="pending">Pending</option>
                  </select>
                  <has-error :form="form" field="status"></has-error>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <label for="date">Date</label>
                <input type="date" v-model="form.paymentDate" name="paymentDate" class="form-control" @change="changeFilter( null, this.per_page)" placeholder="EMI Date">
              </div>
              <div class="col-md-3">
                <label for="date">Payment Start Date</label>
                <input type="date" v-model="form.paymentStartDate" name="paymentStartDate" class="form-control" @change="changeFilter" placeholder="EMI Date">
              </div>
              <div class="col-md-3">
                <label for="date">Payment End Date</label>
                <input type="date" v-model="form.paymentEndDate" name="paymentEndDate" class="form-control" @change="changeFilter" placeholder="EMI Date">
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- Default box -->
        <div class="info-box">
          <div class="box-header with-border" v-if="canAccess('member-collection-create')">
            <h3 class="box-title">Advance Security Records</h3>
            
            <div class="box-tools">
              <a :href="`${this.$axios.defaults.baseURL}/advanceemisecurity/export/excel?paymentStartDate=${form.paymentStartDate}&paymentEndDate=${form.paymentEndDate}&branch_id=${branch_id}`" class="btn btn-box-tool" v-if="canAccess('collection-center-member-create')">
                <i class="fa fa-file-excel-o"></i> Download Excel
              </a>
              <!-- <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('branch-create')">
                <i class="fa fa-plus"></i> Add New
              </button> -->
            </div>
  
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-6 col-xs-6">
                <label>
                  <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
                <strong>Amt :</strong> {{totalAmt}}
              </div>
              <div class="col-sm-6 col-xs-6">
                <div class="input-group pull-right input-group-sm" style="width: 150px;">
                  <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search by City">
  
                  <div class="input-group-btn">
                    <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <div style="overflow:auto;">
              <table class="table table-sm table-bordered table-hover">
                <thead style="background-color: #d6dddd;">
                  <tr>
                    <th class="hidden-xs">Sr.</th>
                    <th>LoanID </th>
                    <th>Mem Name </th>
                    <th class="hidden-xs">Alias</th>
                    <th class="hidden-xs">Mobile</th>
                    <th class="hidden-xs">Type</th>
                    <th class="hidden-xs">CenterName</th>
                    <th class="hidden-xs">Pay Date</th>
                    <th>Amount</th>
                    <th class="hidden-xs">Received By</th>
                    <th class="hidden-xs">Created</th>
                    <th class="hidden-xs">Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in rowsMemberCollections" :key="index">
                    <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                    <td><i class="fa fa-user text-info"></i> <span v-if="row.member_loan_plan">{{ row.member_loan_plan.applicationNo }}</span></td>
                    <td>{{ row.member.name }}<br> ({{ row.member.code }})</td>
                    <td class="hidden-xs">{{ row.member.alias }}</td>
                    <td class="hidden-xs"> <i class="fa fa-mobile"></i> {{ row.member.mobile }}</td>
                    <td class="hidden-xs"><i v-if="row.type === 'panulty'">penalty</i><i v-else>{{ row.type }}</i></td>
                    <td class="hidden-xs"><span v-if="row.collection_center_id">{{ row.collection_center.name }} ({{ row.collection_center.centerCode }})</span></td>
                    <td class="hidden-xs"><span style="font-size:12px;"> {{ row.paymentDate | myDate }}</span></td>
                    <td><i>₹ {{ row.amt }}/- </i> <br><span class="text-success" style="font-size:10px;" v-if="row.branch_ledger">({{ row.branch_ledger.ledger.name }})</span></td>
                    <td class="hidden-xs"><span v-if="row.received_by">{{ row.received_by.name }} <span class="text-primary">({{ row.received_by.code }})</span></span></td>
                    <td class="hidden-xs"> {{ row.created_at }} <br><span class="text-info" style="font-size:10px;">[{{ row.ipAddress }}]</span></td>
                    <td class="hidden-xs"> {{ row.status }}  
                    </td>
                    <td>
                      <div class="btn-group">
                        <button type="button" class="btn btn-info btn-flat btn-xs dropdown-toggle" title="Click Here To Drop-Down" data-toggle="dropdown">
                          Task <span class="caret"></span>
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right" role="menu">
                          <li v-if="row.status === 'approved' && row.voucher.length > 0 && canAccess('voucher-view')">
                            <a @click="voucherView(row.id)">Ledger Entry<i class="fa fa-book" aria-hidden="true"></i></a>
                          </li>
                          <li><a @click="printView(row)">View <i class="fa fa-print" aria-hidden="true"></i></a></li>
                          <li v-if="canAccess('member-collection-delete')"><a @click="deleteAdvanceSecurity(row)">Delete <i class="fa fa-trash"></i></a></li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- /.box-body -->
          <div class="box-footer clearfix" v-if="pagination.current_page > 0">
            <div class="row">
              <div class="col-sm-4">
                Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
              </div>
              <div class="col-sm-8">
                <ul class="pagination pagination-sm no-margin pull-right">
                  <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                  <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>
  
                  <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                  <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                  <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                  <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                  <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                  <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                  <li><a href="#">...</a></li>
                  
                  <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                  <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                  <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>
  
                  <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                  <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- Payment Receipt Model -->
        <payreceiptview :seeRecord="seeRecord"></payreceiptview>
  
        <!-- EMI Payment Voucher Entry Record -->
        <emivoucherentry :ventries="ventries"></emivoucherentry>
      </section>
      <!-- /.content -->
    </div>
  </template>
  
  <script>
  import emivoucherentry from '../components/EmiVoucherEntry.vue'
  import payreceiptview from '../components/PaymentReceipt.vue'
  // var _ = require('lodash')
  export default {
    name: 'my-component',
    data () {
      return {
        pagination: {
          current_page: 0,
          from: 0,
          to: 0,
          total: 0,
          last_page: 0,
          per_page: 0,
          first_page_url: null,
          last_page_url: null,
          next_page_url: null,
          prev_page_url: null,
          path: null
        },
        per_page: 10,
        table_search: '',
        isLoading: false,
        editMode: false,
        emiDate: null,
        collectionCenters: [],
        collectionCenter: {},
        applicationNumber: '',
        memberCode: '',
        mobileNumber: '',
        adharCardNumber: '',
        pancardNumber: '',
        totalAmt: 0,
        branches: [],
        branchFilter: {},
        branch_id: '',
        branch: {},
        members: {},
        staffs: {},
        pl: {},
        seeRecord: {},
        loanplans: [],
        memberloanplans: [],
        memberloanplan: {},
        groupMembers: {},
        loadDisbursements: {},
        totalAmount: 0,
        viewCollectionCenter: '',
        totalRecords: 0,
        ventries: [],
        ventry: {},
        serverParams: {
          columnFilters: {
          },
          sort: {
            field: 'paymentDate',
            type: 'date'
          },
          page: 1,
          perPage: 10
        },
        form: new Form({
          id: '',
          collection_center_id: '',
          member_loan_plan_id: null,
          branch_id: '',
          agent_id: '',
          center_leader_id: '',
          plan_id: '',
          amt: '',
          plan: {},
          planType: '',
          member_id: '',
          status: '',
          disbursement_id: '',
          paymentDate: '',
          paymentStartDate: '',
          paymentEndDate: '',
          emiStartDate: '',
          paymentMode: '',
          bank_id: ''
        }),
        rowsMemberCollections: []
      }
    },
    methods: {
      canAccess (perm) {
        return this.$store.state.permissions.includes(perm)
      },
      updateParams (newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps)
      },
      changeByBankFilter () {
        this.branch_id = ''
        if (this.branchFilter) {
          this.branch_id = this.branchFilter.id
        }
      },
      onPageChange (params) {
        // console.log(' value')
        // console.log(params)
        this.updateParams({page: params.currentPage})
        this.changeFilter()
      },
      onPerPageChange (params) {
        this.updateParams({perPage: params.currentPerPage})
        this.changeFilter()
      },
      onSortChange (params) {
        // console.log(params)
        // console.log(this.columnsMemberCollections[4])
        this.updateParams({
          sort: [{
            type: params.sortType,
            field: this.columnsMemberCollections[4].field
          }]
        })
        this.changeFilter()
      },
      onColumnFilter (params) {
        this.updateParams(params)
        this.changeFilter()
      },
      voucherView (id) {
        this.ventries = []
        this.$axios
          .get('voucher?member_collection_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.ventries = data.data.data
            console.log(data.data.data)
            console.log('voucher entry')
          })
          .catch(function (error) {
            console.log(error)
          })
        $('#voucherView').modal({backdrop: 'static', keyboard: false})
      },
      printView (row) {
        this.seeRecord = {}
        this.seeRecord = row
        $('#payReceiptView').modal({backdrop: 'static', keyboard: false})
      },
      deleteAdvanceSecurity (row) {
        Swal.fire({ title: 'Are you sure?', text: 'You Delete this Payment !', icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, Delete it!' })
        .then((result) => {
          if (result.isConfirmed) {
            this.$axios.delete('advanceemisecurity/' + row.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
              .then(() => {
                Fire.$emit('AfterCreate')
                Swal.fire('Delete!', 'Record Deleted Successfully.', 'success')
              })
          }
        })
      },
      planName (plan) {
        var pln = JSON.parse(plan)
        this.form.member_loan_plan_id = null
        return pln.name
      },
      changeFilter (page = null, pg = null) {
        var c = JSON.parse(localStorage.user)
        // alert(c.agent_profile.branch_id)
        var pageUrl = ''
        if (this.pagination.first_page_url && pg === 'first') {
          pageUrl += this.pagination.first_page_url
        } else if (this.pagination.last_page_url && pg === 'last') {
          pageUrl += this.pagination.last_page_url
        } else if (this.pagination.next_page_url && pg === 'next') {
          pageUrl += this.pagination.next_page_url
        } else if (this.pagination.prev_page_url && pg === 'prev') {
          pageUrl += this.pagination.prev_page_url
        } else if (this.pagination.path != null) {
          pageUrl += this.pagination.path
        } else {
          pageUrl += 'advanceemisecurity'
        }
  
        if (pg == null) {
          pageUrl += `?per_page=${this.per_page}`
        } else {
          pageUrl += `&per_page=${this.per_page}`
        }
        if (c.type === 'staff') {
          if (c.role.name === 'Agent' || c.role.name === 'Field Officer') {
            // this.branch.id = c.agent_profile.branch_id
            pageUrl += `&agent_id=${c.id}`
          }
        }
        if (this.branch_id) {
          pageUrl += `&branch_id=${this.branch_id}`
        }
        if (this.form.status) {
          pageUrl += `&status=${this.form.status}`
        }
        if (this.form.planType) {
          pageUrl += `&loanType=${this.form.planType}`
        }
        if (this.collectionCenter.id) {
          pageUrl += `&collection_center_id=${this.collectionCenter.id}`
        }
        if (this.form.paymentStartDate) {
          pageUrl += `&paymentStartDate=${this.form.paymentStartDate}`
        }
        if (this.form.paymentEndDate) {
          pageUrl += `&paymentEndDate=${this.form.paymentEndDate}`
        }
        if (this.form.paymentDate) {
          pageUrl += `&paymentDate=${this.form.paymentDate}`
        }
        if (this.table_search) {
          pageUrl += `&memberCity=${this.table_search}`
        }
        if (page != null) {
          pageUrl += `&page=${page}`
        }
        this.$axios
          .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
          .then((data) => {
            console.log(data)
            this.rowsMemberCollections = data.data.data
            this.totalAmt = _.sumBy(this.rowsMemberCollections, function (o) { return Number(o.amt) })
            this.pagination = data.data
          }).catch(function (error) { console.log(error) })
      },
      getLoanDetailsMemberCode () {
        this.$axios
        .get('memberloanplan?all=all&applicationNo=' + this.memberCode, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            // console.log(data.data.data)
           // alert(data.data.data)
            this.form.member_loan_plan_id = data.data[0]['id']
            this.changeFilter()
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      getPlanType () {
        this.form.collection_center_id = ''
        this.form.member_loan_plan_id = ''
        this.memberloanplans = []
        this.rows = []
        this.rowsMemberCollections = []
        if (this.form.planType === 'individual') {
          this.collectionCenters = []
          this.collectionCenter = {}
        }
        if (this.form.planType === 'group') {
          this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then((response) => response.data)
            .then((data) => {
              this.collectionCenters = data.data
              _.forEach(this.collectionCenters, function (item, key) {
                this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
              }.bind(this))
            })
            .catch(
              function (error) {
                Toast.fire({ icon: 'error', title: 'Please Try Again' })
                this.form.errors.errors = error.response.data.error
              }.bind(this)
            )
        }
        this.changeFilter()
        // if (this.emiDate) {
        //   this.getEMIRecord()
        // } else {
        //   this.getMemberLoanPlan()
        // }
        // this.form.member_id = null
      },
      getMemberAndGroupAndAgent () {
        this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.collectionCenters = data.data
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
  
        this.$axios
          .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.staffs = data.data
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      },
      loadBranch () {
        this.$axios
          .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.branches = data.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      loadGroupMember (id) {
        this.$axios
          .get('collectioncentermember?all=all&collection_center_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.groupMembers = data.data
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    components: {
      emivoucherentry,
      payreceiptview
    },
    created () {
      this.loadBranch()
      this.changeFilter()
      Fire.$on('AfterCreate', () => {
        this.changeFilter((this.pagination.current_page > 0) ? this.pagination.current_page : null)
      })
    }
  }
  </script>
  <style scoped>
  .content {
      padding: 0px;
    }
    .info-box {
      border-radius:10px;
      box-shadow: 0px 0px 3px gray;
    }
    .box-footer {
      border-radius:0px 0px 10px 10px;
    }
  </style>



// WEBPACK FOOTER //
// AdvanceSecurity.vue?085f0da0